import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { LocaleType } from '/@/modules/user/constants/LocaleType';
import { getters } from '/@/modules/core/app/helpers/store';

export class PersonTitle extends Enum {
  key!: string;
  value!: string;

  static MR: PersonTitle = {
    key: 'mr',
    get value(): string {
      return Lang.t('contact.mr');
    }
  };

  static MRS: PersonTitle = {
    key: 'mrs',
    get value(): string {
      return Lang.t('contact.mrs');
    }
  };

  static MS: PersonTitle = {
    key: 'ms',
    get value(): string {
      return Lang.t('contact.ms');
    }
  };

  static MISS: PersonTitle = {
    key: 'miss',
    get value(): string {
      return Lang.t('contact.miss');
    }
  };

  static getPersonTitlesByLanguage(): PersonTitle[] {
    const language: string = getters?.auth.getUser()?.locale;
    return language === LocaleType.FRENCH
      ? [PersonTitle.MR, PersonTitle.MRS, PersonTitle.MISS]
      : [PersonTitle.MR, PersonTitle.MRS, PersonTitle.MS, PersonTitle.MISS];
  }
}
